'use strict';

var React = require('react');

var SvgTipJarIcon = function SvgTipJarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 7.25a1.875 1.875 0 0 0 0 3.75h1.25a.375.375 0 0 1 0 .75h-2.375a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 1.5 0h.125a1.875 1.875 0 0 0 0-3.75h-1.25a.375.375 0 1 1 0-.75h2.375a.75.75 0 0 0 0-1.5h-.75a.75.75 0 0 0-1.5 0h-.125Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.75 5.77c0-.187.022-.368.065-.542a1 1 0 0 1 .685-1.728h7a1 1 0 0 1 .685 1.728c.042.174.065.355.065.542a.77.77 0 0 0 .289.6l.055.044a2.42 2.42 0 0 1 .906 1.886v5.45a2.75 2.75 0 0 1-2.75 2.75h-5.5a2.75 2.75 0 0 1-2.75-2.75v-5.45c0-.733.334-1.427.906-1.886l.055-.043a.77.77 0 0 0 .289-.601Zm1.5 0c0-.095.017-.186.049-.27h5.402a.768.768 0 0 1 .049.27c0 .69.313 1.341.852 1.772l.054.044a.915.915 0 0 1 .344.714v5.45c0 .69-.56 1.25-1.25 1.25h-5.5c-.69 0-1.25-.56-1.25-1.25v-5.45c0-.278.126-.54.344-.714l.054-.044a2.27 2.27 0 0 0 .852-1.772Z"
  }));
};
SvgTipJarIcon.displayName = "TipJarIcon";

exports.SvgTipJarIcon = SvgTipJarIcon;
